import { render, staticRenderFns } from "./ReceivableManagement.vue?vue&type=template&id=12d2bbfc&scoped=true"
import script from "./ReceivableManagement.vue?vue&type=script&lang=ts"
export * from "./ReceivableManagement.vue?vue&type=script&lang=ts"
import style0 from "./ReceivableManagement.vue?vue&type=style&index=0&id=12d2bbfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2bbfc",
  null
  
)

export default component.exports